// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ooc4","tabsBox":"styles_tabsBox__KQuSD","createButton":"styles_createButton__3AAro"};